import { Factory } from 'fishery'
import faker from 'faker'

export default Factory.define<APIResponse.InsuranceCatalog>(() => ({
  stateName: faker.address.state(),
  stateAbbreviation: faker.address.stateAbbr(),
  insurances: [],
}))
